import ReactECharts from "echarts-for-react";
import { AgentChartSpec } from "./agentChartSpec";

const SERIES_COLOURS = ["#2f6f4e", "#c9622e", "#3b6ea5", "#8a6fa8", "#7a7a7a"];

const AgentChart = ({ spec }: { spec: AgentChartSpec }) => {
  const option = {
    grid: { left: 56, right: 16, top: spec.title ? 48 : 24, bottom: 56 },
    title: spec.title
      ? { text: spec.title, left: "center", textStyle: { fontSize: 13 } }
      : undefined,
    tooltip: { trigger: "axis" },
    legend:
      spec.series.length > 1
        ? { bottom: 0, type: "scroll", textStyle: { fontSize: 11 } }
        : undefined,
    xAxis: {
      type: "category",
      data: spec.x,
      axisLabel: { fontSize: 10, hideOverlap: true },
    },
    yAxis: {
      type: "value",
      name: spec.unit,
      nameTextStyle: { fontSize: 10 },
      axisLabel: { fontSize: 10 },
    },
    series: spec.series.map((s, i) => ({
      name: s.name,
      type: s.type === "bar" ? "bar" : "line",
      data: s.data,
      smooth: false,
      symbol: "none",
      // Gaps must read as gaps: joining across a null would draw a straight
      // line through missing data, which is the exact misreading the agent is
      // meant to be preventing.
      connectNulls: false,
      itemStyle: { color: SERIES_COLOURS[i % SERIES_COLOURS.length] },
      lineStyle: { width: 1.6 },
    })),
  };
  if (spec.error) {
    // A chart the server could not vouch for. Showing the reason beats drawing a
    // series whose axis it has already said is misleading.
    return (
      <div
        className="my-3 p-2 rounded"
        style={{ background: "#fff4f4", fontSize: "0.85em" }}
      >
        <strong>Chart not shown.</strong> {spec.error}
      </div>
    );
  }
  return (
    <div className="my-3">
      <ReactECharts
        option={option}
        style={{ height: 260, width: "100%" }}
        notMerge
      />
    </div>
  );
};

export default AgentChart;
